import RouteContainer from "./pages/index";
import "./App.css";
import { GlobalStyles } from "twin.macro";
import AOS from "aos";
import "aos/dist/aos.css";
import "react-toastify/dist/ReactToastify.css";
import Toaster from "assets/lib/toast";
import "./i18n";
import { ThemeProvider } from "@mui/material";
import { innerTheme } from "assets/lib/theme";

AOS.init();
function App() {
  return (
    <ThemeProvider theme={innerTheme}>
      <GlobalStyles />
      <div>{RouteContainer}</div>
      <Toaster />
    </ThemeProvider>
  );
}

export default App;
